export const FORM_RENDERED_EVENT = 'cms_form.rendered'
